<template>
  <!-- 案件詳細 -->
  <div id="HolterDepositMachineDetail">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">基本情報</span>
        <table>
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <tr><th>機種</th><td>{{data.model | getNameFilter(models)}}</td></tr>
          <tr><th>検査期間</th><td>{{data.inspectionPeriod | getNameFilter(inspectionPeriodList)}}</td></tr>
          <tr v-if="!isHideAnalysisOptions"><th>解析オプション（有料）</th><td>{{data.analysisOption | getNameFilter(analysisOptionList)}}</td></tr>
          <tr v-if="data.judgmentFlag"><th>判定医</th><td><b-checkbox style="width:26px;" value="true" disabled v-model="data.judgment"/>前回と違う判定医に依頼する。</td></tr>
          <tr><th>配送先</th><td>医療機関に配達する</td></tr>
          <tr><th>郵便番号</th><td>{{data.zip}}</td></tr>
          <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address}}</td></tr>
          <tr><th>住所（丁目、番地）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address1}}</td></tr>
          <tr><th>住所（建物名、号室）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address2}}</td></tr>
          <tr><th>宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receiverName}}</td></tr>
          <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
          <tr><th>配達希望時間帯</th><td>{{data.desiredDeliveryTimeZone | getNameFilter(timeZone)}}</td></tr>
          <tr><th colspan="2">【{{data.model | getNameFilter(models)}}】</th></tr>
          <tr><th>出荷日</th><td>{{data.shippingDate | formatDate()}}</td></tr>
          <tr><th>契約院内貸出機台数</th><td>{{data.depositMachineRentalNumber}}</td></tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
export default {
  name: "HolterDepositMachineDetail",
  props: ["data"],
  data() {
    let models = this.getChoiceList(choicesType.holterKind, true);
    let timeZone = this.getChoiceList(choicesType.deliveryTime, true);
    let inspectionPurposeList = this.getChoiceList(choicesType.holterInspectionPurpose, true);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    return {
      models: models,
      timeZone: timeZone,
      inspectionPurposeList: inspectionPurposeList,
      analysisOptionList: analysisOptionList,
      inspectionPeriodList: inspectionPeriodList,
      atLaunchHidden: atLaunchHidden,
      isHideAnalysisOptions: true
    };
  },
  filters: {
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/HolterDepositMachineDetail.vue